import { useQuery as useBaseQuery } from "@edreamsodigeo/frontend-api-client-base";
import { GqlObj } from "../gql-tag/types";
import {
  Variables,
  UseQueryResult,
  QueryOptsWithVars,
  QueryOpts,
  QueryOptsWithOptionalVars,
  QueryOptions,
} from "./types";

/**
 * Performs a graphql query to frontend-api. After any mutation, the query will be re-fetched
 *
 * @remarks
 * You can customize the query with graphql operation directives:
 * - \@ignore_update: Avoid perform query after mutations
 * - \@update_groups(groups: "groupName1,groupName2"): Perform query after mutations only if mutation and query have a match in update groups
 *
 * @param query - Graphql query operation, builded with gql constructor
 * @param options - Query options, included query params
 *
 * @returns Query response and current status of the query
 */
export function useQuery<TData>(
  query: GqlObj,
  options?: QueryOpts<TData>
): UseQueryResult<TData>;

export function useQuery<TData, TVars extends Variables>(
  query: GqlObj,
  options: QueryOptsWithOptionalVars<TData, TVars>
): UseQueryResult<TData, TVars>;

export function useQuery<TData, TVars extends Variables>(
  query: GqlObj,
  options: QueryOptsWithVars<TData, TVars>
): UseQueryResult<TData, TVars>;

export function useQuery<TData, TVars extends Variables | undefined>(
  query: GqlObj,
  options?: QueryOptions<TData, TVars>
): UseQueryResult<TData, TVars> {
  return useBaseQuery<TData, TVars>(query, options);
}
